const ContentStudioIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Cursive writing */}
    <path
      d="M-1 17.5C0 15.5 1 14 2 16C3 18 3.5 14 5 16C6 17.5 6.5 17 7 16.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      fill="none"
    />
    {/* Pen body - tip meets end of writing */}
    <path
      d="M13.5 1L17 4.5L8 14H3.5V9.5L13.5 1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    {/* Pen collar line */}
    <line
      x1="11.5"
      y1="3"
      x2="15"
      y2="6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default ContentStudioIcon;
